import type {
  AnalysisStatus,
  Attribution,
  ConnectionState,
  ExclusionReason,
  GapReason,
  HistoryImportStatus,
  Intent,
  MessageType,
  PrimaryMotive,
  ResponseStatus,
  Role,
  TouchKind,
  TranscriptStatus,
} from './enums.js';

// Spanish product copy for enumerations. Used by the UI and CSV export so both agree.

export const ROLE_LABELS: Record<Role, string> = {
  owner: 'Propietario',
  manager: 'Gerente',
  viewer: 'Lector',
};

export const CONNECTION_STATE_LABELS: Record<ConnectionState, string> = {
  disconnected: 'Desconectado',
  awaiting_qr: 'Esperando QR',
  connecting: 'Conectando',
  syncing: 'Sincronizando',
  connected: 'Conectado',
  reconnecting: 'Reconectando',
  logged_out: 'Sesión cerrada',
  error: 'Error',
  paused: 'En pausa',
};

export const ATTRIBUTION_LABELS: Record<Attribution, string> = {
  assigned: 'Agente asignado',
  shared: 'Compartido / sin atribuir',
  unassigned: 'Sin asignar',
};

export const HISTORY_IMPORT_LABELS: Record<HistoryImportStatus, string> = {
  not_started: 'Sin importar',
  in_progress: 'Importando',
  completed: 'Importación recibida',
  partial: 'Parcial',
  failed: 'Falló',
};

export const GAP_REASON_LABELS: Record<GapReason, string> = {
  disconnected: 'Número desconectado',
  history_incomplete: 'Historial incompleto',
  before_import: 'Antes del historial importado',
  lease_lost: 'Interrupción del procesamiento',
  unknown: 'Cobertura incierta',
};

export const EXCLUSION_REASON_LABELS: Record<ExclusionReason, string> = {
  personal: 'Chat personal',
  internal: 'Conversación interna',
  spam: 'Spam',
  test: 'Prueba',
  other: 'Otro',
};

export const MESSAGE_TYPE_LABELS: Record<MessageType, string> = {
  text: 'Texto',
  voice: 'Nota de voz',
  audio: 'Audio',
  image: 'Imagen',
  video: 'Video',
  document: 'Documento',
  sticker: 'Sticker',
  location: 'Ubicación',
  contact: 'Contacto',
  other: 'Otro',
};

export const TRANSCRIPT_STATUS_LABELS: Record<TranscriptStatus, string> = {
  pending: 'Transcripción pendiente',
  completed: 'Transcrito',
  failed: 'Transcripción fallida',
  unavailable: 'Audio no disponible',
  disabled: 'Transcripción desactivada',
};

export const TOUCH_KIND_LABELS: Record<TouchKind, string> = {
  initial_outreach: 'Contacto inicial',
  initial_response: 'Respuesta inicial',
  follow_up: 'Seguimiento',
  active_response: 'Respuesta en conversación activa',
};

export const RESPONSE_STATUS_LABELS: Record<ResponseStatus, string> = {
  responded: 'Respondido',
  pending: 'Sin respuesta',
  not_applicable: 'No aplica',
  uncertain: 'Incierto',
};

export const ANALYSIS_STATUS_LABELS: Record<AnalysisStatus, string> = {
  pending: 'Análisis pendiente',
  running: 'Analizando',
  completed: 'Evaluado',
  insufficient_evidence: 'Evidencia insuficiente',
  failed: 'Análisis fallido',
  disabled: 'IA desactivada',
  budget_limited: 'Límite de presupuesto',
  stale: 'Desactualizado',
};

export const PRIMARY_MOTIVE_LABELS: Record<PrimaryMotive, string> = {
  pricing: 'Precio',
  availability: 'Disponibilidad',
  information: 'Información',
  appointment: 'Cita / visita',
  financing: 'Financiamiento',
  purchase: 'Compra',
  support: 'Soporte',
  other: 'Otro',
  unknown: 'Desconocido',
};

export const INTENT_LABELS: Record<Intent, string> = {
  exploring: 'Explorando',
  comparing: 'Comparando',
  ready_to_proceed: 'Listo para avanzar',
  post_sale: 'Postventa',
  unknown: 'Desconocida',
};

export const WEEKDAY_LABELS: Record<string, string> = {
  '1': 'Lunes',
  '2': 'Martes',
  '3': 'Miércoles',
  '4': 'Jueves',
  '5': 'Viernes',
  '6': 'Sábado',
  '7': 'Domingo',
};
